module.exports = {
    name:      "headsortails",
    buildDate: "Tue Nov 19 2019 13:18:09 GMT+0000 (GMT)",
    version:   "1.0.0",
    build:     "193.2642 debug"
};



// WEBPACK FOOTER //
// ./src/version.js